<script setup lang="ts">
import type { MJContext } from "./document.vue";

interface MJMLSectionProps {
    context?: MJContext;
    backgroundColor?: string;
    innerBackgroundColor?: string;
    border?: string;
    borderBottom?: string;
    borderLeft?: string;
    borderRight?: string;
    borderTop?: string;
    borderRadius?: string;
    innerBorder?: string;
    innerBorderBottom?: string;
    innerBorderLeft?: string;
    innerBorderRight?: string;
    innerBorderTop?: string;
    innerBorderRadius?: string;
    width?: string;
    verticalAlign?: string;
    padding?: string;
    hasMany?: boolean;
    paddingTop?: string;
    paddingBottom?: string;
    paddingLeft?: string;
    paddingRight?: string;
    cssClass?: string;
    nonRawElements?: number;
}

const props = withDefaults(defineProps<MJMLSectionProps>(), {
    backgroundColor: undefined,
    innerBackgroundColor: undefined,
    border: "none",
    borderBottom: undefined,
    borderLeft: undefined,
    borderRight: undefined,
    borderTop: undefined,
    borderRadius: undefined,
    innerBorder: undefined,
    innerBorderBottom: undefined,
    innerBorderLeft: undefined,
    innerBorderRight: undefined,
    innerBorderTop: undefined,
    innerBorderRadius: undefined,
    width: undefined,
    nonRawElements: 1,
    verticalAlign: "top",
    padding: undefined,
    paddingTop: undefined,
    paddingBottom: undefined,
    paddingLeft: undefined,
    paddingRight: undefined,
    cssClass: undefined,
});
</script>

<template>
    <div
        :class="cssClass"
        :style="{
            fontSize: 0,
            textAlign: 'left',
            direction: context?.dir ?? 'ltr',
            display: 'inline-block',
            verticalAlign: props.verticalAlign,
            width:
                width ?? (nonRawElements ? `${100 / nonRawElements}%` : `100%`),
        }"
    >
        <div
            align="center"
            border="0"
            cellpadding="0"
            cellspacing="0"
            role="presentation"
            :style="{
                verticalAlign: props.verticalAlign,
            }"
            width="100%"
        >
            <div>
                <div>
                    <div
                        :style="{
                            backgroundColor,
                            border:
                                borderBottom ||
                                borderLeft ||
                                borderRight ||
                                borderTop
                                    ? undefined
                                    : border,
                            borderBottom,
                            borderLeft,
                            borderRight,
                            borderTop,
                            borderRadius,
                            verticalAlign,
                            padding,
                            paddingTop,
                            paddingBottom,
                            paddingLeft,
                            paddingRight,
                        }"
                    >
                        <div
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            role="presentation"
                            style=""
                            width="100%"
                        >
                            <div>
                                <slot
                                    :styles="{
                                        backgroundColor: innerBackgroundColor,
                                        border: innerBorder,
                                        borderBottom: innerBorderBottom,
                                        borderLeft: innerBorderLeft,
                                        borderRight: innerBorderRight,
                                        borderTop: innerBorderTop,
                                        borderRadius: innerBorderRadius,
                                    }"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
